module.exports = __webpack_public_path__ + "images/sgp/SizeGuide/5x15.svg";